<template>
  <div v-if="visible" class="share-overlay" @click.self="$emit('close')"></div>
  <div v-if="visible" class="share-modal" role="dialog" aria-label="공유 방법 선택">
    <div class="share-modal-inner">
      <div class="share-handle" aria-hidden="true"></div>
      <h2 class="share-title">공유하기</h2>
      <div class="share-options">
        <button v-if="showKakaoOption" type="button" class="share-option kakao" @click.stop="$emit('select', 'kakao')">
          <span class="share-option-icon-wrap kakao"><span class="share-option-icon">💬</span></span>
          <span class="share-option-label">카카오톡으로 보내기</span>
        </button>
        <button type="button" class="share-option twitter" @click.stop="$emit('select', 'twitter')">
          <span class="share-option-icon-wrap twitter"><span class="share-option-icon">𝕏</span></span>
          <span class="share-option-label">트위터(X)로 공유</span>
        </button>
        <button v-if="hasNativeShare" type="button" class="share-option native" @click.stop="$emit('select', 'native')">
          <span class="share-option-icon-wrap"><span class="share-option-icon">📤</span></span>
          <span class="share-option-label">다른 앱으로 공유</span>
        </button>
        <button type="button" class="share-option copy" @click.stop="$emit('select', 'copy')">
          <span class="share-option-icon-wrap"><span class="share-option-icon">🔗</span></span>
          <span class="share-option-label">링크 복사</span>
        </button>
      </div>
      <button type="button" class="share-cancel" @click.stop="$emit('close')">취소</button>
    </div>
  </div>
</template>

<script>
import { isDesktop } from "@/utils/pageMeta";

export default {
  name: "ShareOptionsModal",
  props: {
    visible: { type: Boolean, default: false },
  },
  emits: ["close", "select"],
  computed: {
    showKakaoOption() {
      return !isDesktop();
    },
    hasNativeShare() {
      return typeof navigator !== "undefined" && !!navigator.share;
    },
  },
};
</script>

<style scoped>
.share-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 900;
  animation: shareFadeIn 0.2s ease-out;
}

@keyframes shareFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.share-modal {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 901;
  padding: 0 12px;
  animation: shareSlideUp 0.25s ease-out;
}

@keyframes shareSlideUp {
  from {
    transform: translateY(100%);
    opacity: 0.95;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.share-modal-inner {
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 8px 0 0;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);
  max-width: 320px;
  margin: 0 auto;
}

.share-handle {
  width: 28px;
  height: 3px;
  margin: 0 auto 10px;
  background: #e0e0e0;
  border-radius: 2px;
}

.share-title {
  margin: 0 0 10px;
  padding: 0 16px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.share-options {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 8px;
}

.share-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: none;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 13px;
  color: #333;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.share-option:hover,
.share-option:active {
  background: #f5f5f5;
}

.share-option-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f0f0f0;
  flex-shrink: 0;
}

.share-option-icon {
  font-size: 14px;
  line-height: 1;
}

.share-option-icon-wrap.kakao {
  background: #fee500;
}

.share-option-icon-wrap.kakao .share-option-icon {
  font-size: 15px;
}

.share-option.kakao:hover,
.share-option.kakao:active {
  background: #fef9e6;
}

.share-option-icon-wrap.twitter {
  background: #1a1a1a;
}

.share-option-icon-wrap.twitter .share-option-icon {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.share-option.twitter:hover,
.share-option.twitter:active {
  background: #f0f0f0;
}

.share-option-label {
  flex: 1;
}

.share-cancel {
  display: block;
  width: calc(100% - 16px);
  margin: 8px 8px 0;
  padding: 10px;
  border: 1px solid #e9ecef;
  background: #fff;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease;
}

.share-cancel:hover,
.share-cancel:active {
  background: #f5f5f5;
  color: #333;
}
</style>
